(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('templates/userForm.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2025 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<form class="form-horizontal" name="adminUserForm">',
'',
'  <div ng-if="!model">no model</div>',
'',
'  <div class="row user-form" ng-init="view={edit_login: false}">',
'',
'    <div class="col-md-6">',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.sn}">',
'        <label class="col-sm-4" for="sn" translate>user.sn</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.sn" class="form-control" id="sn" placeholder="{{\'user.sn\' | translate}}" ng-required="required.sn">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.givenName}">',
'        <label class="col-sm-4" for="givenName" translate>user.gn</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.givenName" class="form-control" id="givenName" placeholder="{{\'user.gn\' | translate}}" ng-required="required.givenName">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.cn}">',
'        <label class="col-sm-4" for="commonName" translate>user.cn</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.cn" class="form-control" id="commonName" placeholder="{{\'user.cn\' | translate}}" disabled ng-required="required.cn">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.mail}">',
'        <label class="col-sm-4" for="email" translate>user.mail</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.mail" type="email" class="form-control" id="email" placeholder="{{\'user.mail\' | translate}}" ng-required="required.mail">',
'        </div>',
'      </div>',
'      <div class="form-group form-group-sm" ng-class="{required: required.postalAddress}">',
'        <label class="col-sm-4" for="address" translate>user.address</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.postalAddress" class="form-control" id="address" placeholder="{{\'user.address\' | translate}}" ng-required="required.postalAddress"></textarea>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.org}">',
'        <label class="col-sm-4" for="organization" translate>user.org</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.org" class="form-control" id="organization" organizations model="model" promise="promise" placeholder="{{\'user.org\' | translate}}" ng-required="required.org">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.description}">',
'        <label class="col-sm-4" for="organization" translate>user.description</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.description" class="form-control" id="description" placeholder="{{\'user.description\' | translate}}" ng-required="required.description"></textarea>',
'        </div>',
'      </div>',
'      <div class="form-group form-group-sm" ng-class="{required: required.manager}">',
'        <label class="col-sm-4" for="manager" translate>user.manager</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.manager" class="manager form-control" id="manager" managers promise="promise" ng-required="required.manager">',
'        </div>',
'      </div>',
'      <div class="form-group form-group-sm" ng-class="{required: required.shadowExpire}">',
'        <label class="col-sm-4" for="shadowExpire" translate>user.expire</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.shadowExpire" class="form-control" id="shadowExpire" placeholder="{{\'user.expire\' | translate}}" datepicker ng-required="required.shadowExpire">',
'        </div>',
'      </div>',
'',
'    </div>',
'',
'    <div class="col-md-6">',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.telephoneNumber}">',
'        <label class="col-sm-4" for="phone" translate>user.phone</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.telephoneNumber" class="form-control" id="phone" placeholder="{{\'user.phone\' | translate}}" ng-required="required.telephoneNumber">',
'        </div>',
'      </div>',
'      <div class="form-group form-group-sm" ng-class="{required: required.facsimileTelephoneNumber}">',
'        <label class="col-sm-4" for="fax" translate>user.fax</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.facsimileTelephoneNumber" class="form-control" id="fax" placeholder="{{\'user.fax\' | translate}}" ng-required="required.facsimileTelephoneNumber">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.title}">',
'        <label class="col-sm-4" for="title" translate>user.title</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.title" class="form-control" id="title" placeholder="{{\'user.title\' | translate}}" ng-required="required.title">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.privacyPolicyAgreementDate}">',
'        <label class="col-sm-4" for="privacyPolicyAgreementDate" translate>user.privacyPolicyAgreementDate</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.privacyPolicyAgreementDate" class="form-control" id="privacyPolicyAgreementDate" disabled placeholder="{{\'user.privacyPolicyAgreementDate\' | translate}}" datepicker ng-required="required.privacyPolicyAgreementDate">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm">',
'        <label class="col-sm-4" for="creationDate" translate>user.creationDate</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.createTimestamp" class="form-control" id="creationDate" disabled placeholder="{{\'user.lastLoginUnknown\' | translate}}">',
'        </div>',
'      </div>',
'      <div class="form-group form-group-sm">',
'        <label class="col-sm-4" for="lastLogin" translate>user.lastLogin</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.authTimestamp" class="form-control" id="lastLogin" disabled placeholder="{{\'user.lastLoginUnknown\' | translate}}">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.knowledgeInformation}">',
'        <label class="col-sm-4" for="knowledgeInformation" translate>user.note</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.knowledgeInformation" class="form-control" id="knowledgeInformation" placeholder="{{\'user.note\' | translate}}" ng-required="required.knowledgeInformation"></textarea>',
'        </div>',
'      </div>',
'',
'      <hr>',
'',
'      <div class="form-group" ng-if="model.$promise" ng-class="{required: required.uid && !model.isExternalAuth}">',
'        <label class="col-sm-4" for="uid" ng-if="!model.isExternalAuth" translate>user.login</label>',
'        <label class="col-sm-4" for="uid" ng-if="model.isExternalAuth" translate>account.external</label>',
'        <div class="col-sm-8 break-word" ng-if="!view.edit_login">',
'          <div ng-if="model.isExternalAuth"><b>{{ model.oAuth2Provider }} :</b><br></div>',
'          {{model.uid}} <span ng-if="!model.isExternalAuth">(<a href="javascript:void(0)" ng-click="view.edit_login=!view.edit_login">change</a>)</span>',
'        </div>',
'        <div class="col-sm-8" ng-if="view.edit_login">',
'          <!-- Server validation is in java/org/georchestra/console/ws/newaccount/NewAccountFormController.java -->',
'          <input ng-model="model.uid" class="form-control" id="uid" placeholder="{{\'user.login\' | translate}}" ng-required="required.uid" ng-pattern="/^[a-z][a-z0-9_\\\\.\\\\-]*$/i">',
'        </div>',
'      </div>',
'      <hr ng-if="!model.isExternalAuth">',
'',
'      <div class="form-group form-group-sm" ng-if="model.$promise && !model.isExternalAuth" ng-class="{required: required.preferredLanguage}">',
'        <label class="col-sm-4" for="givenName" translate>user.password</label>',
'        <a href="/console/account/passwordRecovery?email={{user.user.mail | encodeURIComponent}}"',
'          target="_blank" class="col-sm-8 password">',
'          <span translate>user.reset</span>',
'          <i class="glyphicon glyphicon-new-window"></i>',
'        </a>',
'      </div>',
'',
'      <div ng-if="platformInfos.saslEnabled">',
'        <div class="form-group form-group-sm" ng-if="model.$promise">',
'          <label class="col-sm-4" for="saslUser">',
'            <span translate>sasl.remote.user</span>',
'            {{ platformInfos.saslServer }}',
'            <span title="{{\'sasl.tooltip\' | translate}}" class="glyphicon glyphicon-info-sign"></span>',
'          </label>',
'          <div class="col-sm-8">',
'            <input id="saslUser" type="text" class="form-control" ng-model="model.saslUser">',
'          </div>',
'        </div>',
'      </div>',
'    </div>',
'  </div>',
'',
'</form>',
'',''].join("\n"));
  }]);
})();